import { render, staticRenderFns } from "./PublicLink.vue?vue&type=template&id=1e30dab3&scoped=true"
import script from "./PublicLink.vue?vue&type=script&lang=ts"
export * from "./PublicLink.vue?vue&type=script&lang=ts"
import style0 from "./PublicLink.vue?vue&type=style&index=0&id=1e30dab3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e30dab3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e30dab3')) {
      api.createRecord('1e30dab3', component.options)
    } else {
      api.reload('1e30dab3', component.options)
    }
    module.hot.accept("./PublicLink.vue?vue&type=template&id=1e30dab3&scoped=true", function () {
      api.rerender('1e30dab3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PublicLink.vue"
export default component.exports